import classNames from 'classnames';
import Preact, { Component } from 'preact';
import testId from '../../../helpers/testId';
interface Props {
  openManagePref: boolean;
  handleManagePref: Function;
  setHasResponse: Function;
  hasCookieResponse?: boolean;
}

export class CookieBannerPopup extends Component<Props> {
  openManagePreference = () => {
    this.props.handleManagePref(true, false);
  };
  acceptAllCookies = () => {
    if (window.CookieConsent)
      window.CookieConsent.submitCustomConsent(true, true, true);
    var cb = document.getElementById('CybotCookiebotDialogv2');
    if (cb) {
      cb.style.display = 'none';
    }
    this.props.handleManagePref(false, false);
    this.props.setHasResponse(true);
  };

  acceptEssentialCookies = () => {
    if (window.CookieConsent)
      window.CookieConsent.submitCustomConsent(false, false, false);
    var cb = document.getElementById('CybotCookiebotDialogv2');
    if (cb) {
      cb.style.display = 'none';
    }
    this.props.handleManagePref(false, false);
    this.props.setHasResponse(true);
  };

  render() {
    const BannerPopupContainerClass = classNames(
      testId('cookiebanner-popup'),
      'cookiebanner-popup',
    );
    const acceptCookiesClass = classNames(testId('accept-all-cookies'));

    return (
      <div id="jg-cookiebot-popup-container">
        <div className={BannerPopupContainerClass} id="cookiebanner-popup">
          <div id="cookiebanner-title">
            {
              <p id="cookiebanner-title-p">
                Before you continue to <br /> JustGiving
              </p>
            }
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="cookie-banner-description-container">
              <div
                id={'popup-cookie-desc'}
                className="desc"
                style="overflow: auto"
              >
                <p>
                  {' '}
                  We use cookies to enrich and personalise your user experience
                  on this site. Click “Accept all cookies” to accept all
                  essential and non-essential cookies.
                  <br />
                  <br />
                  If you want to only use essential cookies then click on
                  "Essential cookies only", alternatively if you want to decide
                  which non-essential cookies are used on the site, click on
                  "Customise" to modify your preferences. Find out more about
                  cookies by reading our{' '}
                  <a
                    href="https://www.justgiving.com/about/info/cookie-notice"
                    target="_blank"
                  >
                    cookie policy.
                  </a>
                </p>
              </div>
            </div>
            <div class="row-footer direction-column">
              <div class="row-footer-1">
                <div class="column-footer-2">
                  {' '}
                  <button
                    id="accept-all-Cookies"
                    className={classNames(
                      acceptCookiesClass,
                      'primary-cookie-button',
                    )}
                    onClick={this.acceptAllCookies.bind(this)}
                  >
                    {' '}
                    {`Accept all cookies`}
                  </button>
                </div>
                <div class="column-footer-2">
                  {' '}
                  <button
                    id="accept-essential-Cookies"
                    className={classNames(
                      acceptCookiesClass,
                      'primary-cookie-button',
                    )}
                    onClick={this.acceptEssentialCookies.bind(this)}
                  >
                    {' '}
                    {`Essential cookies only`}
                  </button>
                </div>
              </div>
              <div class="column-footer-2">
                {' '}
                <a
                  id="customise-footer"
                  onClick={this.openManagePreference.bind(this)}
                >
                  {' '}
                  Customise{' '}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CookieBannerPopup;
